export const SelectedTabQueryParamValues = {
    STATS: 's',
    PLAY_BY_PLAY: 'pbp',
    HEAD_TO_HEAD: 'h2h',
    LINEUPS: 'l',
    CUP: 'c',
    OFFER: 'o',
    SOCIAL: 'sc',
    STANDINGS: 'st',
    PREMATCH_STATS: 'ps',
} as const;

export type TSelectedTabQueryParamValues =
    typeof SelectedTabQueryParamValues[keyof typeof SelectedTabQueryParamValues];
